"use client";

import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { useEffect } from "react";

export default function CountAnimation({ number, className }: { number: number; className?: string }) {
  // Start at 0, animate up to `number`
  const count = useMotionValue(0);

  // Determine if number has decimals
  const hasDecimals = !Number.isInteger(number);

  // Round to the nearest integer, then apply Intl formatting
  const formattedCount = useTransform(count, (latest) =>
    new Intl.NumberFormat("de-DE", {
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: hasDecimals ? 2 : 0,
    }).format(latest)
  );

  useEffect(() => {
    const animation = animate(count, number, {
      duration: 2,
    });
    return () => animation.stop();
  }, [count, number]);

  // Use `formattedCount` to display the final output
  return <motion.h4 className={className}>{formattedCount}</motion.h4>;
}
